import type { FC } from 'react';
import PageContainer from '@ui/PageContainer';
import PageTitle from '@ui/PageTitle';
import useHomePage from './useHomePage';

const HomePage: FC = () => {
	useHomePage();

	return (
		<PageContainer>
			<PageTitle>Home</PageTitle>
		</PageContainer>
	);
};

export default HomePage;
